import {
  conGptIndicatorImage,
  doazGptIndicatorImage,
  riskCheckerIndicatorImage,
} from "@root/assets/riskchecker";
import { QUERY_TYPE, RESPONSE_STATUS, ROLES } from "@root/constants";
import { WEB_PROJECTS } from "@root/webConstants";
import { generateRandomId } from "./dateHelper";
import { isStringType } from "./helpers";
import { t } from "i18next";

export const getSystemTypeChatItem = (chat: any, prevChat: any): any[] => {
  let chatItem: any[] = [];
  if ((chat?.chatId || chat?.id) && prevChat) {
    chatItem = [
      {
        id: prevChat?.id,
        role: ROLES.USER,
        input: prevChat?.input,
        threadId: chat?.threadId,
        chatId: chat?.chatId,
        meta: prevChat,
      },
      {
        id: prevChat?.id,
        role: ROLES.ASSISTANT,
        output: chat?.response,
        threadId: chat?.threadId,
        chatId: chat?.chatId,
        meta: chat,
      },
    ];
  }
  return chatItem;
};

export const RISKCHECKER_CHAT_STATUS = {
  SUCCESS: "success",
  ERROR: "error",
  PENDING: "pending",
};

export const getSystemTypeChat = (chat: any[]) => {
  const systemTypeChat = chat.flatMap((c: any): any => {
    const {
      answer,
      chatId,
      threadId,
      question,
      url,
      url_type,
      webpage_summary,
      description,
      type,
      title,
      transcript,
      table_of_contents,
      summary,
      detailed_summary,
    } = c;
    let systemAnswer: any = {};

    try {
      if (url_type === QUERY_TYPE.WEBSITE) {
        systemAnswer.response = webpage_summary;
      } else if (url_type === QUERY_TYPE.PDF) {
        systemAnswer.response = description;
      } else if (url_type === QUERY_TYPE.YOUTUBE) {
        systemAnswer.response = table_of_contents + summary + detailed_summary;
      } else {
        systemAnswer = JSON.parse(answer); //
        systemAnswer = JSON.parse(systemAnswer); // safely parse the answer
        // safely parse the answer
      }
    } catch (error) {
      console.error("Failed to parse answer", error);
      systemAnswer.response = null;
    }
    const id = generateRandomId("chat-history");
    const { response } = systemAnswer;

    function handleInput() {
      if (
        type === RESPONSE_STATUS.WEBPAGE ||
        type === RESPONSE_STATUS.FILE ||
        type === RESPONSE_STATUS.YOUTUBE
      ) {
        // return `${t("chat.summarizeUrl")} ${url}`;
        return url;
      }
      return question;
    }

    return [
      {
        id,
        role: ROLES.USER,
        input: handleInput(),
        threadId: threadId,
        chatId: chatId,
        meta: { c, ...systemAnswer },
      },
      {
        id,
        role: ROLES.ASSISTANT,
        output: response,
        threadId: threadId,
        chatId: chatId,
        meta: { c, ...systemAnswer },
      },
    ].reverse();
  });

  return systemTypeChat?.reverse();
};

export const isRiskcheckerChat = (id: number) => {
  if (id === WEB_PROJECTS.RISK_CHECKER.id) {
    return true;
  }
  return false;
};
export function removeDuplicates(data: Array<any>): Array<any> {
  const uniqueEntries = new Map();

  for (const item of data) {
    const key = `${item.role}-${item.id}`;
    if (!uniqueEntries.has(key)) {
      uniqueEntries.set(key, item);
    }
  }

  return Array.from(uniqueEntries.values());
}
export const isConGptChat = (id: number) => {
  if (id === WEB_PROJECTS.CON_GPT.id) {
    return true;
  }
  return false;
};

export const isDoazGptChat = (id: number) => {
  if (id === WEB_PROJECTS.DOAZ_GPT.id) {
    return true;
  }
  return false;
};

export const getProjectsIconById = (id: number) => {
  let img = undefined;
  switch (id) {
    case WEB_PROJECTS.RISK_CHECKER.id:
      img = riskCheckerIndicatorImage;
      break;
    case WEB_PROJECTS.CON_GPT.id:
      img = conGptIndicatorImage;
      break;
    case WEB_PROJECTS.DOAZ_GPT.id:
      img = doazGptIndicatorImage;
      break;
  }
  return img;
};

export const isPendingStatus = (status: string) => {
  if (status === RISKCHECKER_CHAT_STATUS.PENDING) {
    return true;
  }
  return false;
};
export const notFoundCase = (status: string) => {
  if (!status) {
    return true;
  }
  return false;
};
export const isSuccessStatus = (status: string) => {
  if (status === RISKCHECKER_CHAT_STATUS.SUCCESS) {
    return true;
  }
  return false;
};
export const isErrorStatus = (status: string) => {
  if (status === RISKCHECKER_CHAT_STATUS.ERROR) {
    return true;
  }
  return false;
};

export const getRiskcheckerUploadingImageIndex = (
  totalSelectedImages: number,
  totalSrcImages: number
) => {
  if (totalSelectedImages > totalSrcImages) {
    if (totalSrcImages + 1 === totalSelectedImages) {
      return totalSrcImages;
    }
  }
  return -1;
};

export function greetUserBasedOnTime() {
  const now = new Date();
  const hours = now.getHours();

  if (hours >= 5 && hours > 12) {
    return t("common:translate.hello");
  } else if (hours >= 12 && hours < 18) {
    return t("common:translate.hello");
  } else {
    return t("common:translate.hello");
  }
}
